module.exports = __webpack_public_path__ + "img/mkt_desktop_failed.4cfc0617.svg";